<template>
  <section
    id="hero-alt"
    class="hh-hero-alt"
  >
    <div
      class="hh-hero-alt__aurora"
      aria-hidden="true"
    />

    <v-container class="hh-hero-alt__container">
      <v-breadcrumbs
        :items="items"
        class="pa-0 mb-3 hh-hero-alt__crumbs"
        divider="/"
      />
      <h1 class="hh-h2 mb-0">
        {{ title }}
      </h1>
    </v-container>

    <div class="hh-spectrum-bar" />
  </section>
</template>

<script>
  export default {
    name: 'SectionHeroAlt',

    metaInfo () {
      return {
        changed: meta => (this.title = meta.titleChunk),
      }
    },

    data: () => ({
      title: '',
    }),

    computed: {
      items () {
        return [
          { text: 'Home', to: '/', exact: true },
          { text: this.title },
        ]
      },
    },
  }
</script>

<style lang="sass">
  .hh-hero-alt
    position: relative
    overflow: hidden
    background: rgba(14, 10, 51, .35)

    &__aurora
      position: absolute
      top: -60%
      right: -10%
      width: 50vw
      height: 50vw
      max-width: 700px
      max-height: 700px
      pointer-events: none
      background: radial-gradient(closest-side, rgba(16, 0, 232, .5), rgba(106, 15, 216, .3) 45%, rgba(232, 58, 240, .15) 70%, transparent 100%)
      filter: blur(40px)

    &__container
      position: relative
      padding-top: 72px
      padding-bottom: 40px

      @media (max-width: 959px)
        padding-top: 40px
        padding-bottom: 28px

    .v-breadcrumbs__item
      color: var(--hh-muted) !important
      font-size: .9rem

    .v-breadcrumbs__divider
      color: var(--hh-muted)
</style>
